export const mergeStyles = (...classNames: string[]) => classNames.join(' ')
